import { CSSProperties, memo, useMemo } from 'react';

// import DefaultBody from '../../../assets/graphics/png/collections/avatar/bodies/avatars-bodies-0000_0001.png';
import {
  AvatarArmsItemNo,
  AvatarAurasItemNo,
  AvatarBodiesItemNo,
  AvatarFeetItemNo,
  AvatarHatsItemNo,
  // AvatarId,
  AvatarNecksItemNo,
  AvatarWingsItemNo,
} from '../../../constants/AvatarItem';
import { NOT_APPLICABLE_STRING } from '../../../constants/general';
import { Profile } from '../../../models/UserStore';
// import { getFilePrefix } from '../../../utils/avatar';
import {
  DefaultProfilePic,
  DefaultProfilePicProps,
} from '../DefaultProfilePicture';
import { JoyajoyImage, JoyajoyImageFile } from '../JoyajoyImage';

import './AvatarNode.css';

type ProfileImageProps = {
  [K in keyof JoyajoyImageFile as K extends 'resource'
    ? 'source'
    : K]: JoyajoyImageFile[K];
};

// type AvatarNodeItemProps = {
//   id: AvatarId | null | undefined;
//   style?: CSSProperties;
//   isBody?: boolean;
// };

// const AvatarNodeItemContent = memo(
//   ({ id, isBody, style }: AvatarNodeItemProps) => {
//     return id ? (
//       <img className="avatar-item" src={getFilePrefix(id)} style={style} />
//     ) : isBody ? (
//       <img className="avatar-item" src={DefaultBody} style={style} />
//     ) : null;
//   },
// );

export type AvatarProps = DefaultProfilePicProps &
  ProfileImageProps & {
    body?: AvatarBodiesItemNo | null;
    hat?: AvatarHatsItemNo | null;
    arms?: AvatarArmsItemNo | null;
    feet?: AvatarFeetItemNo | null;
    wings?: AvatarWingsItemNo | null;
    neck?: AvatarNecksItemNo | null;
    aura?: AvatarAurasItemNo | null;
    style?: CSSProperties;
  };

type AvatarNodeProps =
  | {
      avatar: AvatarProps;
      profile?: undefined;
      size?: number;
    }
  | {
      profile: Profile;
      avatar?: undefined;
      size?: number;
    };

export const AvatarNode = memo(
  ({ avatar, profile, size = 48 }: AvatarNodeProps) => {
    const {
      source,
      fileType,
      imageVersion,
      // body = null,
      // arms,
      // hat,
      // feet,
      // wings,
      // neck,
      // aura,
      userId,
    } = useMemo(() => {
      if (avatar) {
        return avatar;
      }
      return {
        userId: profile?.userId,
        source:
          profile?.profilePicture && profile?.profilePicture.publicUrls?.small
            ? { uri: profile?.profilePicture.publicUrls?.small }
            : NOT_APPLICABLE_STRING,
        ...profile?.avatar,
      };
    }, [avatar, profile?.avatar, profile?.profilePicture, profile?.userId]);

    const resources = {
      resource: source,
      fileType,
      imageVersion,
    } as JoyajoyImageFile;

    // const getNodeProps = useCallback((id: AvatarId | null | undefined) => {
    //   return {
    //     id,
    //   };
    // }, []);

    return (
      <div className="avatar-node" style={{ width: size, height: size }}>
        {/* <AvatarNodeItemContent
          {...getNodeProps(aura)}
          style={{ width: size, height: size }}
        />
        <AvatarNodeItemContent
          {...getNodeProps(feet)}
          style={{ width: size, height: size }}
        />
        <AvatarNodeItemContent
          {...getNodeProps(body)}
          isBody
          style={{ width: size, height: size }}
        />
        <AvatarNodeItemContent
          {...getNodeProps(neck)}
          style={{ width: size, height: size }}
        />
        <AvatarNodeItemContent
          {...getNodeProps(arms)}
          style={{ width: size, height: size }}
        />
        <AvatarNodeItemContent
          {...getNodeProps(wings)}
          style={{ width: size, height: size }}
        />
        <AvatarNodeItemContent
          {...getNodeProps(hat)}
          style={{ width: size, height: size }}
        /> */}

        <div className="profile-pic flex justify-center items-center">
          {source ? (
            <JoyajoyImage {...resources} className="image" />
          ) : (
            <DefaultProfilePic userId={userId} />
          )}
        </div>
      </div>
    );
  },
);
